import { APIHelper } from '@archistarai/auth-frontend';

export default {
  async store(siteGuid: string) {
    return APIHelper.ArchistarAPI.post('map/getScenarioGuidByPropGuid', {
      propGuid: siteGuid
    });
  }
};
